var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',{staticClass:"top-advice"},[_c('ul',{staticClass:"top-advice-list"},_vm._l((_vm.advice),function(article){return _c('TopAdviceListItem',{key:article.id,attrs:{"post":article}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }